import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software", to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
const generateStyle = (componentTheme, props, state) => {
  const hoverTime = state.hoverTime;
  return {
    timebar: {
      label: 'timebar',
      flex: '100%',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      '&:focus': {
        border: 'none',
        outline: `.125rem solid ${componentTheme.progressBackgroundColor}`,
        outlineOffset: '-.25rem',
        borderRadius: '.25rem',
        padding: '.375rem'
      }
    },
    buffered: {
      label: 'buffered',
      height: '100%'
    },
    viewed: {
      label: 'viewed',
      height: '100%',
      backgroundColor: componentTheme.progressBackgroundColor,
      borderRight: componentTheme.progressSeparatorBorder
    },
    rest: {
      label: 'rest',
      height: '100%',
      flex: 1,
      backgroundColor: componentTheme.restBackgroundColor
    },
    timebarWrapper: {
      label: 'timebarWrapper',
      display: 'flex',
      flexGrow: 1,
      position: 'relative',
      borderCollapse: 'collapse'
    },
    timebarContent: {
      label: 'timebarContent',
      fontWeight: componentTheme.timestampFontWeight,
      fontSize: componentTheme.timestampFontSize,
      color: componentTheme.timestampColor,
      borderLeft: 'solid 1px #D7DADE',
      padding: componentTheme.timestampPadding,
      height: '100%',
      display: 'grid',
      placeItems: 'center',
      zIndex: componentTheme.timestampZIndex
    },
    tooltipContainer: _objectSpread(_objectSpread({
      label: 'tooltipContainer',
      backgroundColor: componentTheme.tooltipContainerColor,
      width: '1px',
      top: 0,
      bottom: 0,
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      pointerEvents: 'none'
    }, !hoverTime && {
      label: 'tooltipContainer-hidden',
      visibility: 'hidden'
    }), {}, {
      '&:focus': {
        outline: 'none'
      }
    }),
    tooltipContent: {
      label: 'tooltipContent',
      marginTop: componentTheme.tooltipTop,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    tooltip: {
      label: 'tooltip',
      color: componentTheme.tooltipColor,
      fontWeight: componentTheme.tooltipFontWeight,
      fontSize: componentTheme.tooltipFontSize,
      backgroundColor: componentTheme.tooltipBackgroundColor,
      padding: componentTheme.tooltipPadding,
      borderRadius: componentTheme.tooltipBorderRadius
    },
    tooltipCaret: {
      label: 'tooltipCaret',
      width: 0,
      height: 0,
      borderTop: `${componentTheme.tooltipCaretSize} solid #fff`,
      borderLeft: `${componentTheme.tooltipCaretSize} solid transparent`,
      borderRight: `${componentTheme.tooltipCaretSize} solid transparent`
    },
    tooltipLine: {
      label: 'tooltipLine',
      backgroundColor: componentTheme.tooltipBackgroundColor,
      width: componentTheme.tooltipLineWidth,
      height: componentTheme.tooltipLineHeight
    },
    playhead: {
      label: 'playhead',
      position: 'absolute',
      top: 0,
      '& button': {
        zIndex: componentTheme.playheadButtonZIndex
      }
    }
  };
};
export default generateStyle;